<template>
  <div class="box">
    <v-row class="">
      <v-col class="py-0">
        <VSelect
          v-model="data.cycleType"
          :label="$t('treatmentProgram.step2.cycleType')"
          :items="cycleTypes"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <p class="pb-0 mb-0 titleModal">
      {{ $t(`treatmentProgram.steam.step3.injectionDuration`) }}
    </p>
    <v-row>
      <v-col class="pb-0">
        <VSelect
          v-model="data.durationOfInjection.day"
          :label="$t('treatmentProgram.steam.step2.day')"
          :items="daysOfWeek"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <p class="mb-0">
      {{ $t('treatmentProgram.steam.step3.startHour') }}
    </p>
    <v-row class="pt-0">
      <v-col class="pt-0 mt-0">
        <VTimePicker
          v-model="data.durationOfInjection.startHour"
          dense
          @input="updateData"
        />
      </v-col>
    </v-row>
    <p class="mb-0 pb-0">
      {{ $t('treatmentProgram.steam.step3.duration.title') }}
    </p>
    <v-row>
      <v-col class="d-flex pt-0">
        <VTextField
          v-model="data.durationOfInjection.duration.hour"
          :label="$t('treatmentProgram.steam.step3.duration.hour')"
          type="number"
          :rules="{min:1, max:2, max_value:24, min_value:0}"
          outlined
          hideDetails
          flat
          @input="updateData"
        /> <p class="px-3">
          :
        </p>
        <VTextField
          v-model="data.durationOfInjection.duration.min"
          :label="$t('treatmentProgram.steam.step3.duration.min')"
          type="number"
          :rules="{min:1, max:2, min_value:0, max_value:59}"
          outlined
          hideDetails
          flat
          @input="updateData"
        /><p
          class="p-3"
          justify="center"
        >
          :
        </p>
        <VTextField
          v-model="
            data.durationOfInjection.duration.sec"
          :label="$t('treatmentProgram.steam.step3.duration.sec')"
          type="number"
          :rules="{min:1, max:2, min_value:0, max_value:59}"
          outlined
          hideDetails
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>

    <p class="xPadding titleModal mb-0">
      {{ $t(`treatmentProgram.step2.prebleed`) }}
    </p>
    <v-row>
      <v-col class="py-0">
        <VSelect
          v-model="data.prebleed.active"
          :label="$t('treatmentProgram.step2.prebleed')"
          :items="yesNo"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="data.prebleed.active">
      <v-col class="py-0">
        <VTextField
          v-model="data.prebleed.value"
          :label="$t('treatmentProgram.step2.duration')"
          :formatNumber="true"
          type="number"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.prebleed.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="prebleedUnit"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <p class="xPadding titleModal mb-0">
      {{ $t(`treatmentProgram.step2.blowdownLockOut`) }}
    </p>
    <v-row>
      <v-col class="py-0">
        <VSelect
          v-model="data.blowdownLockOut.active"
          :label="$t('treatmentProgram.step2.blowdownLockOut')"
          :items="yesNo"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import { CYCLE_TYPES, DAYS_OF_WEEK, PREBLEED_UNIT, BLOWDOWNLOCKOUT_UNIT } from '@/constants/steamTreatmentPrograms';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTimePicker from '@/components/shared/widgets/forms/VuetifyInputs/VTimePicker.vue';

export default {
    components: {
        VTextField,
        VTimePicker,
    },
    props: {
        schedule: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
        cycleTypes() {
            return CYCLE_TYPES.map(type => ({
                name: this.$t(`treatmentProgram.steam.step3.cycleTypes.${type}`),
                key: type,
            }));
        },
        daysOfWeek() {
            return DAYS_OF_WEEK.map(day => ({
                name: this.$t(`daysOfWeek.${day}`),
                key: day,
            }));
        },
        yesNo() {
            return ['yes', 'no'].map(key => ({
                name: this.$t(`treatmentProgram.steam.step3.${key}`),
                key: key === 'yes',
            }));
        },
        prebleedUnit() {
            return PREBLEED_UNIT.map(key => ({
                name: this.$t(`treatmentProgram.steam.step3.PrebleedUnit.${key}`),
                key,
            }));
        },
        blowdownLockOutUnit() {
            return BLOWDOWNLOCKOUT_UNIT.map(key => ({
                name: this.$t(`treatmentProgram.steam.step3.PrebleedUnit.${key}`),
                key,
            }));
        },
    },
    watch: {
        model: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.schedule) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            const formatedData = { ...this.data };
            let { hour, min, sec } = formatedData.durationOfInjection.duration;
            if (sec) sec = sec.toString();
            if (hour) hour = hour.toString();
            if (min) min = min.toString();

            this.$emit('sendData', { schedule: formatedData });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type]
                ? this.treatmentProgramUnits[type] : [];
        },
        isTrue(property) {
            return property === 0;
        },
    },
};
</script>
  <style lang="scss" scoped>
  .box {
      width: 100%;
      padding: 0 1rem;
  }
  .date-picker {
    width: 100%;
  }
  </style>
